import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import axios from 'axios';
import Moment from 'moment';
// material
import {
  Card,
  Table,
  Stack,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Container,
  Typography,
  MenuItem,
  TableContainer,
  TablePagination,
  TextField,
  Grid,
  IconButton,
  Avatar,
  Popover,
  Chip,
} from '@mui/material';
import { Box } from '@mui/system';
import CopyToClipboard from 'react-copy-to-clipboard';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Close, Visibility } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Filter from '../components/filters/AdminFilter';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import Popup from '../components/popups/AdminStatusChange';

export default function Admins() {
  const accountData = JSON.parse(localStorage.getItem('profile'));
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState();
  const [pages, setPages] = useState(0);
  const [adminCount, setAdminCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedIndex1, setSelectedIndex1] = useState();
  const size = 10;
  const [options, setOptions] = useState({ size, page: 0 });
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open3, setOpen3] = useState(false);

  const adminSchema = Yup.object().shape({
    fullname: Yup.string().required('Fullname is required').min(4, 'Fullname must be at least 4 charecters'),
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    accType: Yup.string().required('Account type is required'),
    password: Yup.string().required('Password is required').min(8, 'Password must be at least 6 charecters'),
  });

  const formik = useFormik({
    initialValues: {
      fullname: '',
      email: '',
      accType: 'SUB_ADMIN',
      password: '',
    },
    validationSchema: adminSchema,
    onSubmit: async () => {
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/create`, values);
        if (!res.data.isError) {
          closeAddAdminModal(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        getAdmins(options);
        resetForm();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    },
  });
  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${!item.isBlocked}` === event.target.value) {
      return;
    }
    console.log(index);
    setSelectedIndex(index);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    if (refresh) {
      getAdmins(options);
    }
    if (message && refresh) {
      toast(message);
    } else if (message && !refresh) {
      toast.error(message);
    }
  };
  const openAddUserModal = () => {
    setOpen(true);
  };
  const closeAddAdminModal = (message) => {
    setOpen(false);
    toast(message);
  };

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    setIsLoading(true);
    getAdmins(temp);
  };

  const getAdmins = (options) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/all`, {
        params: options,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setAdminCount(res.data.data.maxRecords);
          setAdminData(res.data.data.admins);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };



  const goToPage = () => {
    console.log('hi');
    if (input > Math.ceil(adminCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getAdmins(temp);
  };

  const handleOpenPopover = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex1(index);
    setOpen3(true);
    event.stopPropagation();
  };

  const handleClosePopover = (event) => {
    setAnchorEl(null);
    setSelectedIndex1('');
    setOpen3(false);
    event.stopPropagation();
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.id.length) {
      temp.id = filter.id;
    }
    if (filter.fullname.length) {
      temp.fullname = filter.fullname.trim();
    }
    if (filter.id.length) {
      temp.id = filter.id;
    }
    if (filter.email.length) {
      temp.email = filter.email;
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate;
    }
    if (filter.isBlocked.length) {
      temp.isBlocked = filter.isBlocked;
    }

    setOptions(temp);
    setPages(0);
    getAdmins(temp);
  };
  useEffect(() => {
    getAdmins(options);
  }, []);
  return (
    <>
      <Page title="Admins">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* Add admin Dialog */}
            <Dialog open={open}>
              <DialogTitle>Add Admin</DialogTitle>
              <Grid container paddingBottom={'10px'} Width="500px">
                <DialogContent paddingTop="20px">
                  <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                      <Grid item xs={12} md={12} lg={12}>
                        <Stack direction={'column'} spacing={1} width="500px">
                          <Stack direction="row" justifyContent="space-between">
                            <TextField
                              type="text"
                              label="Fullname"
                              fullWidth
                              value={values.fullname}
                              {...getFieldProps('fullname')}
                              error={Boolean(touched.fullname && errors.fullname)}
                              helperText={touched.fullname && errors.fullname}
                            />
                          </Stack>
                          <Stack direction="row" justifyContent="space-between" spacing={1}>
                            <TextField
                              type="text"
                              label="Email"
                              value={values.email}
                              fullWidth
                              {...getFieldProps('email')}
                              error={Boolean(touched.email && errors.email)}
                              helperText={touched.email && errors.email}
                            />
                            <TextField
                              select
                              label="Account Type"
                              fullWidth
                              value={values.accType}
                              {...getFieldProps('accType')}
                              error={Boolean(touched.accType && errors.accType)}
                              helperText={touched.accType && errors.accType}
                            >
                              <MenuItem value="SUB_ADMIN">SUB ADMIN</MenuItem>
                              {/* <MenuItem value="SUPER_ADMIN">SUPER ADMIN</MenuItem> */}
                            </TextField>
                          </Stack>
                          <Stack direction="row" justifyContent="space-between" spacing={1}>
                            <TextField
                              type="password"
                              label="Password"
                              fullWidth
                              value={values.password}
                              {...getFieldProps('password')}
                              error={Boolean(touched.password && errors.password)}
                              helperText={touched.password && errors.password}
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Stack direction={'row'} justifyContent="flex-end" paddingTop="20px">
                        <Button onClick={closeAddAdminModal}>Cancel</Button>
                        <LoadingButton type="submit" loading={isSubmitting}>
                          Add Admin
                        </LoadingButton>
                      </Stack>
                    </Form>
                  </FormikProvider>
                </DialogContent>
              </Grid>
            </Dialog>
            {/* Add admin dialog end */}
            <Container maxWidth="xl">
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ marginBottom: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Admins
                </Typography>
              </Stack>
              <Card>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Stack direction="row" spacing={2} padding={2}>
                    <TextField
                      size="small"
                      style={{ maxWidth: '100px', maxHeight: '35px' }}
                      type="number"
                      component="div"
                      label="Go to"
                      value={input}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          goToPage();
                        }
                      }}
                      onInput={(e) => setInput(e.target.value)}
                    />
                    <Button variant="contained" onClick={goToPage} style={{ maxHeight: '35px' }}>
                      Go
                    </Button>
                  </Stack>
                  <Stack padding={1} direction="row" justifyContent="flex-end" spacing={2} alignItems="center">
                    <Button startIcon={<AddIcon />} variant="contained" onClick={openAddUserModal}>
                      Add Admin
                    </Button>

                    <Filter applyFilters={applyFilters} />
                  </Stack>
                </Stack>

                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      {/* <UserListHead /> */}
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No</TableCell>
                          <TableCell>Profile Pic</TableCell>
                          <TableCell>Fullname</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Account Type</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Date</TableCell>
                          <TableCell>Admin ID</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {adminData?.map((item, id) => (
                          <TableRow key={id} sx={{ '&:hover': { backgroundColor: '#FFE2E2' } }}>
                            <TableCell style={{ width: '50px' }}>{pages * size + (id + 1)}</TableCell>
                            <TableCell>
                              <Avatar
                                alt="User"
                                src={item.profilePic}
                                onClick={(e) => handleOpenPopover(e, id)}
                                sx={{ width: 48, height: 48, cursor: 'pointer' }}
                              />
                              <Popover
                                open={open3 && selectedIndex1 === id}
                                anchorEl={anchorEl}
                                onClose={handleClosePopover}
                                disableRestoreFocus
                                anchorOrigin={{
                                  vertical: 'center',
                                  horizontal: 'center',
                                }}
                                transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center',
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 2,
                                    maxWidth: 280,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <IconButton
                                    onClick={handleClosePopover}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      right: 0,
                                      color: 'text.secondary',
                                    }}
                                  >
                                    <Close />
                                  </IconButton>
                                  <Avatar src={item.profilePic} alt="Avatar" sx={{ width: 200, height: 200 }} />
                                  <Typography
                                    sx={{
                                      lineHeight: 1.2,
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {item.fullname.toUpperCase()}
                                  </Typography>
                                  <Typography variant="body2" align="center" sx={{ color: 'text.secondary' }}>
                                    {item.email}
                                  </Typography>
                                  <Typography variant="body2" align="center" sx={{ color: 'text.secondary' }}>
                                    {item.accType}
                                  </Typography>
                                </Box>
                              </Popover>
                            </TableCell>
                            <TableCell
                              style={{
                                minWidth: '130px',
                                maxWidth: '220px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                              }}
                            >
                              {item?.fullname?.toUpperCase()}
                            </TableCell>
                            <TableCell style={{ minWidth: '130px', wordBreak: 'break-all' }}>{item.email}</TableCell>
                            <TableCell>
                              <Chip
                                // eslint-disable-next-line no-nested-ternary
                                label={item?.accType === 'SUPER_ADMIN' ? 'Supreme Admin' : 'Sub Admin'}
                                // eslint-disable-next-line no-nested-ternary
                                color={item?.accType === 'SUPER_ADMIN' ? 'primary' : 'greenish'}
                              />
                            </TableCell>
                            <TableCell>
                              {item?.accType === 'SUB_ADMIN' ? (
                                <FormControl sx={{ minWidth: 100 }}>
                                  <Select
                                    size="small"
                                    value={!item.isBlocked}
                                    onChange={(e) => handleStatusChange(e, item, id)}
                                  >
                                    <MenuItem value="true">Active</MenuItem>
                                    <MenuItem value="false">Blocked</MenuItem>
                                  </Select>
                                  {selectedIndex === id && <Popup item={item} handleClose={handleClose} />}
                                </FormControl>
                              ) : (
                                <Typography>{item?.isBlocked ? 'Blocked' : 'Active'}</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ minWidth: '120px' }}>
                              {Moment(item.createdAt).format('DD/MM/YYYY')}
                            </TableCell>
                            <TableCell style={{ cursor: 'pointer', width: '80px' }}>
                              <Stack direction="column" spacing={0.5} width="80px">
                                <CopyToClipboard text={item._id} onCopy={() => toast.info('Admin id copied')}>
                                  <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="flex-start">
                                    <Iconify
                                      icon="lucide:clipboard-copy"
                                      style={{ height: '18px', width: '18px', color: '#880808' }}
                                    />
                                    <Typography color="primary" variant="p">
                                      Copy ID
                                    </Typography>
                                  </Stack>
                                </CopyToClipboard>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                sx={{ margin: 0, padding: 0 }}
                                color="primary"
                                onClick={() => {
                                  if (accountData?._id === item._id) {
                                    navigate('/dashboard/profile');
                                  } else {
                                    navigate(`/dashboard/account/view/${item._id}`);
                                  }
                                }}
                              >
                                <Visibility sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component={'div'}
                  count={adminCount}
                  showFirstButton
                  showLastButton
                  onPageChange={handlePageChange}
                  rowsPerPage={size}
                  page={pages}
                />
              </Card>
            </Container>
          </>
        )}
      </Page>
    </>
  );
}
